import React, { useEffect, useRef, useState } from "react";
import { SvgIcon } from "@progress/kendo-react-common";
import { Checkbox } from "@progress/kendo-react-inputs";
import { Popup } from "@progress/kendo-react-popup";
import { gearIcon } from "@progress/kendo-svg-icons";

const GridColumnsChooser = ({
  columns,
  open,
  onOpenChange,
  onToggle,
  onReset,
}) => {
  const [anchor, setAnchor] = useState(null);
  const popupRef = useRef(null);
  const chooserColumns = columns.filter((column) => column.hideable !== false);
  const visibleCount = chooserColumns.filter(
    (column) => column.visible !== false,
  ).length;

  useEffect(() => {
    if (!open) return undefined;

    const handlePointerDown = (event) => {
      if (anchor?.contains(event.target)) return;
      if (popupRef.current?.contains(event.target)) return;
      onOpenChange(false);
    };

    document.addEventListener("pointerdown", handlePointerDown, true);
    return () =>
      document.removeEventListener("pointerdown", handlePointerDown, true);
  }, [open, anchor, onOpenChange]);

  return (
    <>
      <div className="d-flex justify-content-start align-items-center h-100">
        <button
          ref={setAnchor}
          type="button"
          className="border-0 bg-transparent p-0"
          title="Columns"
          aria-label="Choose grid columns"
          aria-expanded={open}
          onClick={(event) => {
            event.stopPropagation();
            onOpenChange(!open);
          }}
          style={{ cursor: "pointer" }}>
          <SvgIcon icon={gearIcon} size="default" style={{ color: "gray" }} />
        </button>
      </div>
      {open && anchor && (
        <Popup
          anchor={anchor}
          show={open}
          animate={false}
          popupAlign={{ horizontal: "left", vertical: "top" }}
          anchorAlign={{ horizontal: "right", vertical: "bottom" }}>
          <div ref={popupRef} className="p-3" style={{ minWidth: 160 }}>
            <div className="fw-semibold mb-2" style={{ fontSize: 13 }}>
              Columns
            </div>
            {chooserColumns.map((column) => {
              const isVisible = column.visible !== false;
              return (
                <div
                  key={column.field}
                  className="d-flex align-items-center mb-2">
                  <Checkbox
                    value={isVisible}
                    disabled={isVisible && visibleCount <= 1}
                    onChange={() => onToggle(column.field)}
                    label={column.title}
                  />
                </div>
              );
            })}
            <button
              type="button"
              className="common-btn bgBtnSecondary w-100 mt-1"
              style={{ fontSize: 12 }}
              onClick={() => {
                onReset();
                onOpenChange(false);
              }}>
              Reset
            </button>
          </div>
        </Popup>
      )}
    </>
  );
};

export default GridColumnsChooser;
